import React, {useState} from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { FaCircleInfo, FaInfo, FaUserPen, FaUserTie } from 'react-icons/fa6';
import { FormInput } from '../../../../htmlComponents/FormInput';
import { FormSelect } from '../../../../htmlComponents/FormSelect';
import { useUserContext } from '../../../../_context/UserContext';
import { User } from '../../../../_models/User.model';
import { validateEmail, validateName, validatePassword } from "../../../Validations";
import { updateCleaners, updateSystemUsers } from '../../../../_utils/resourceAPI';

interface UpdateUserProps{
    toUpdateUser:User
    onUserUpdate: () => void;
}


export const UpdateUser:React.FC<UpdateUserProps> = ({
    toUpdateUser,
    onUserUpdate
}) => {
    const [showUpdateuserModal, setUpdateuserModal] = useState(false);
    const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
    const{userToUpdate,setUserToUpdate} = useUserContext() 
    
    const isFormValid = () => {
      return (
        !validateName(userToUpdate.name, true, "") &&
        !validateEmail(userToUpdate.email, true, "") &&
        !validateName(userToUpdate.username, true, "") &&
        !validatePassword(userToUpdate.password, true, "")
      );
    };

    const handelFormSubmit = () => {
        updateSystemUsers(userToUpdate.id,userToUpdate).then((res) => {
            console.log(res.data);
            console.log("clear User");
            onUserUpdate();
            setUpdateuserModal(false);
          })
          .catch((error) => {
            console.log(error);
          });
    }

    const handleDeleteUser = async () => {
        // Use the latest user data from props to ensure we have the correct ID
        const userToDiscontinue = userToUpdate.id ? userToUpdate : toUpdateUser;
        
        // Ensure we include all required fields from the original user
        const updatedUser: User = {
            id: userToDiscontinue.id,
            name: userToDiscontinue.name,
            username: userToDiscontinue.username,
            password: userToDiscontinue.password,
            role: userToDiscontinue.role,
            email: userToDiscontinue.email,
            discontinued: true
        };
        
        console.log("=== DELETE USER DEBUG ===");
        console.log("Original user:", userToDiscontinue);
        console.log("Updated user to send:", updatedUser);
        console.log("API endpoint:", `PUT v1/system-users/${userToDiscontinue.id}`);
        console.log("Request payload:", JSON.stringify(updatedUser, null, 2));
        
        try {
            const res = await updateSystemUsers(userToDiscontinue.id, updatedUser);
            console.log("=== API RESPONSE ===");
            console.log("Status:", res.status);
            console.log("Response data:", res.data);
            console.log("Full response:", res);
            
            // Refresh the user list
            onUserUpdate();
            // Close modals
            setShowDeleteConfirmationModal(false);
            setUpdateuserModal(false);
        } catch (error: any) {
            console.error("=== API ERROR ===");
            console.error("Error object:", error);
            console.error("Error response:", error?.response);
            console.error("Error data:", error?.response?.data);
            console.error("Error status:", error?.response?.status);
            console.error("Error message:", error?.message);
            alert(`Failed to discontinue user: ${error?.response?.data?.message || error?.message || "Unknown error"}`);
        }
    }

  return (
    <>
    <Button className="btn-warning w-100" 
    onClick={() => {
        console.log("Opening update modal for user:", toUpdateUser);
        setUpdateuserModal(true);
        setUserToUpdate(toUpdateUser);
        }}>
      Update User 
    </Button>
    <Modal
      show={showUpdateuserModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => setUpdateuserModal(false)}
    >
      <Modal.Header closeButton onHide={() => setUpdateuserModal(false)}>
        <Modal.Title id="contained-modal-title-vcenter">
        <FaUserPen /> Update User 
        </Modal.Title>
        
      </Modal.Header>
      <Modal.Body>
      <Row>
        <Col sm={12} className='mb-2 text-danger'>
           <FaCircleInfo/> This users user role is - {userToUpdate.role}
        </Col>
      <Col sm={12}>
        <FormInput
          id="UsersName"
          label="Name"
          type="text"
          value={userToUpdate.name}
          required={true}
          onChange={(value: string) => setUserToUpdate({...userToUpdate,name:value})}
          validator={validateName}
        />
      </Col>
      <Col sm={12}>
        <FormInput
          id="useremail"
          label="User Email"
          type="email"
          value={userToUpdate.email}
          required={true}
          onChange={(value: string) => setUserToUpdate({...userToUpdate,email:value})}
          validator={validateEmail}
        />
      </Col>
      <Col sm={12}>
      <FormInput
          id="UsersUserName"
          label="Username"
          type="text"
          value={userToUpdate.username}
          required={true}
          onChange={(value: string) => setUserToUpdate({...userToUpdate,username:value})}
          validator={validateName}
        />
      </Col>
      <Col sm={12}>
        <FormInput
          id="userPassowrd"
          label="Users Password"
          type="password"
          value={userToUpdate.password}
          required={true}
          onChange={(value: string) => setUserToUpdate({...userToUpdate,password:value})}
          validator={validatePassword}
        />
      </Col>
      <Col sm={12}>
      
          </Col>
      <Col sm={12} className="mt-1">
        <Button className="w-100 btn-success" onClick={handelFormSubmit} disabled={!isFormValid()}>
          Update User
        </Button>
      </Col>
      <Col sm={12} className="mt-2">
        <Button 
          className="w-100 btn-danger" 
          onClick={() => {
            console.log("Delete button clicked. User to delete:", userToUpdate);
            setShowDeleteConfirmationModal(true);
          }}
          disabled={userToUpdate.discontinued === true}
        >
          {userToUpdate.discontinued === true ? "User Discontinued" : "Delete User"}
        </Button>
      </Col>
      {userToUpdate.discontinued === true && (
        <Col sm={12} className="mt-2">
          <div className="text-danger">
            This user has been discontinued
          </div>
        </Col>
      )}
    </Row>
      </Modal.Body>
    </Modal>
    <Modal
      show={showDeleteConfirmationModal}
      onHide={() => setShowDeleteConfirmationModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to discontinue this user? They will not be able to log in after this action.
        <br />
        <strong>User: {userToUpdate.name} ({userToUpdate.email})</strong>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowDeleteConfirmationModal(false)}
        >
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDeleteUser}>
          Yes, Discontinue User
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}
